module.exports = __webpack_public_path__ + "img/rightway-logo-square.c665d7c0.png";